<template>
  <label class="app-checkbox" :class="classObj">
    <input
      class="app-checkbox__input"
      type="checkbox"
      :value="value"
      :true-value="trueValue"
      :false-value="falseValue"
      v-model="model"
    />
    <div class="app-checkbox__dot"></div>
  </label>
</template>

<script>
export default {
  props: {
    value: {},
    checked: {},
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    }
  },
  model: {
    prop: "checked",
    event: "change"
  },
  computed: {
    classObj() {
      return {
        "is-checked": this.checked
      };
    },
    model: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  }
};
</script>

<style lang="scss">
$p: ".app-checkbox";

.app-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  width: 18px;
  height: 18px;
  position: relative;

  &__input {
    display: block;
    appearance: none;
    border: 2px solid colors(palette-2);
    width: 100%;
    height: 100%;
    border-radius: 2px;
    transition: 0.2s all linear;
    position: relative;
    cursor: pointer;
  }

  &__dot {
    width: 8px;
    height: 8px;
    background-color: colors(palette-2);
    transition: 0.2s opacity;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    #{$p}__dot {
      opacity: 0.3;
    }
  }

  &:active {
    #{$p}__dot {
      opacity: 0.5;
    }
  }

  &__input:checked + &__dot {
    opacity: 1;
  }
}
</style>
